import AddExamMapping from "../../Components/Modals/AddExamMapping";
import Table from "../../Components/Table";
import { deleteExamMappingById, getExamMapping } from "../../Services/MasterService";

const ExamMapping = () => {
    const columns = [
        {
            value: "exam_name",
            label: "Exam"
        },
        {
            value: "entity",
            label: "Entity"
        },
        {
            value: "entity_id",
            label: "Entity ID"
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddExamMapping data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getExamMapping}
            columns={columns}
            title={"Exam Mapping"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteExamMappingById}
            disableEdit={true}
        />
    );
}

export default ExamMapping;